import { RotateCcw, Trash2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useEnginePlayActions } from '../hooks/use-engine-play-action'

interface ChatActionButtonProps {
  sessionId: string
  className?: string
}

/**
 * 聊天操作按钮组件
 * 提供重新生成和删除最新消息的功能
 */
export function ChatActionButton({
  sessionId,
  className,
}: ChatActionButtonProps) {
  const {
    regenerateLatestMessage,
    deleteLatestMessage,
    isPolling,
    isRegenerating,
    isDeletingMessage,
  } = useEnginePlayActions(sessionId)

  const toolButtonClass =
    'h-8 w-8 text-white/40 hover:text-white hover:bg-white/10 disabled:opacity-20 transition-all'

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant='ghost'
            size='icon'
            className={cn(toolButtonClass, className)}
            onClick={() => regenerateLatestMessage()}
            disabled={isPolling || isRegenerating}
            title='重新生成'
          >
            <RotateCcw
              className={cn('size-4', isRegenerating && 'animate-spin')}
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent className='border-white/20 bg-black/80 text-xs text-white'>
          重新生成
        </TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant='ghost'
            size='icon'
            className={cn(toolButtonClass, className)}
            onClick={() => deleteLatestMessage()}
            disabled={isDeletingMessage}
            title='删除消息'
          >
            <Trash2
              className={cn('size-4', isDeletingMessage && 'animate-pulse')}
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent className='border-white/20 bg-black/80 text-xs text-white'>
          删除消息
        </TooltipContent>
      </Tooltip>
    </>
  )
}
